var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 14.25C20.49 12.79 22 11.04 22 8.75C22 7.29131 21.4205 5.89236 20.3891 4.86091C19.3576 3.82946 17.9587 3.25 16.5 3.25C14.74 3.25 13.5 3.75 12 5.25C10.5 3.75 9.26 3.25 7.5 3.25C6.04131 3.25 4.64236 3.82946 3.61091 4.86091C2.57946 5.89236 2 7.29131 2 8.75C2 11.05 3.5 12.8 5 14.25L12 21.25L19 14.25Z",
    stroke: "#009CC5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.42bc876d931e22df0f5289e9b57b3564.svg";
export { ForwardRef as ReactComponent };